if (!customElements.get('picture-breakpoint')) {
  let sharedPictureObserver;

  function getSharedObserver() {
    if (!sharedPictureObserver) {
      sharedPictureObserver = new IntersectionObserver((entries, observer) => {
        for (const entry of entries) {
          if (!entry.isIntersecting) continue;
          const element = entry.target;
          element.loadImage();
          observer.unobserve(element);
        }
      }, { rootMargin: '400px 0px' });
    }
    return sharedPictureObserver;
  }

  class PictureBreakpoint extends HTMLElement {
    connectedCallback() {
      if (this.dataset.mounted === 'true') return;

      if ('IntersectionObserver' in window) {
        getSharedObserver().observe(this);
      } else {
        this.loadImage();
      }
    }

    disconnectedCallback() {
      if (sharedPictureObserver) sharedPictureObserver.unobserve(this);
      if (this.dataset.loading === 'true' && this.dataset.mounted !== 'true') {
        delete this.dataset.loading;
      }
    }

    loadImage() {
      if (this.dataset.mounted === 'true') return;
      if (this.dataset.loading === 'true') return;

      const img = this.querySelector('img[data-src]');
      if (!img) return;

      this.dataset.loading = 'true';

      const picture = img.closest('picture');
      const mobileSrcset = this.dataset.mobileSrcset;
      const mobileSizes = this.dataset.mobileSizes;
      const mobileMedia = this.dataset.mobileMedia;

      if (picture && mobileSrcset && mobileMedia) {
        const source = document.createElement('source');
        source.setAttribute('media', mobileMedia);
        if (mobileSizes) source.setAttribute('sizes', mobileSizes);
        source.setAttribute('srcset', mobileSrcset);
        picture.insertBefore(source, img);
      }

      const finish = () => {
        delete this.dataset.loading;
        this.dataset.mounted = 'true';
      };

      img.addEventListener('load', finish, { once: true });
      img.addEventListener('error', finish, { once: true });

      const realAlt = img.getAttribute('data-alt');
      if (realAlt !== null) {
        img.setAttribute('alt', realAlt);
        img.removeAttribute('data-alt');
        img.removeAttribute('aria-hidden');
      }

      const newSrcset = img.getAttribute('data-srcset');
      if (newSrcset) img.setAttribute('srcset', newSrcset);
      img.removeAttribute('data-srcset');

      const newSizes = img.getAttribute('data-sizes');
      if (newSizes) img.setAttribute('sizes', newSizes);
      img.removeAttribute('data-sizes');

      const newSrc = img.getAttribute('data-src');
      if (newSrc) img.setAttribute('src', newSrc);
      img.removeAttribute('data-src');

      if (img.complete && img.naturalWidth > 0) finish();
    }
  }

  customElements.define('picture-breakpoint', PictureBreakpoint);
}
